import { render, staticRenderFns } from "./SpeakStraight2Form.vue?vue&type=template&id=cb5de59e&"
import script from "./SpeakStraight2Form.vue?vue&type=script&lang=js&"
export * from "./SpeakStraight2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports